import { catalogImageAbsoluteUrl } from './catalog-image-url';

const EMPTY_RICH_TEXT = /^(<p><br><\/p>|<p>\s*<\/p>|\s*)$/i;

/** Strip HTML tags and decode common entities for plain-text fallback. */
export function stripHtml(value: string): string {
  return value
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function isMeaningfulRichText(value: string | null | undefined): value is string {
  if (!value) {
    return false;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 && !EMPTY_RICH_TEXT.test(trimmed);
}

/** Extract an image URL from plain text or rich-text HTML. */
export function resolveSettingImageUrl(
  imageBaseUrl: string,
  value: string | null | undefined,
): string | null {
  if (!isMeaningfulRichText(value)) {
    return null;
  }

  const imgMatch = value.match(/<img[^>]+src=["']([^"']+)["']/i);
  if (imgMatch?.[1]) {
    return toAbsoluteAssetUrl(imageBaseUrl, imgMatch[1]);
  }

  const plain = stripHtml(value);
  if (!plain) {
    return null;
  }

  return toAbsoluteAssetUrl(imageBaseUrl, plain);
}

export function toAbsoluteAssetUrl(imageBaseUrl: string, url: string): string {
  const trimmed = url.trim();
  if (!trimmed) {
    return '';
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  if (trimmed.startsWith('lundberg/') || trimmed.startsWith('/lundberg/')) {
    return trimmed.replace(/^\//, '');
  }
  return catalogImageAbsoluteUrl(imageBaseUrl, trimmed);
}
